export const LINKEDIN_EMAIL_STORAGE_KEY = 'linkedin_email';
export const TWITTER_EMAIL_STORAGE_KEY = 'twitter_email';

export const SOCIAL_AUTH_STORAGE_KEYS = [LINKEDIN_EMAIL_STORAGE_KEY, TWITTER_EMAIL_STORAGE_KEY];

export const clearStoredSocialAuth = () =>
  SOCIAL_AUTH_STORAGE_KEYS.forEach((storageKey) => window.localStorage.removeItem(storageKey));
